import classes from "./AiUseCases.module.scss"
import { ReactComponent as CleanEnergyMarketplace } from "../../../assets/icons/CleanEnergyMarketplace.svg"
import { ReactComponent as GreenfundAi } from "../../../assets/icons/GreenfundAi.svg"

const AiUseCases = () => {
    return (
        <div className={classes['ai-use-cases-container']}>
            <div className={classes['ai-use-cases-image']}>
                <img src={"https://se-website-image.s3.ap-south-1.amazonaws.com/robots.png"} alt="" className={classes["image-ai-use-cases"]} />
                <div className={classes['image-text']}>

                    Pioneering Industry Transformation with <span>AI Use-Cases</span>
                </div>
            </div>

            <div className={classes['solution-card-container']}>
                <div className={classes['greenfund-ai-container']}>
                    <div className={classes['logo-conatiner']}>
                        <div className={classes['logo-frame']}>
                            <div className={classes['logo-inside-frame']}>
                                <CleanEnergyMarketplace />
                            </div>
                        </div>
                    </div>
                    <div className={classes['content-container']}>
                        <div className={classes['content-heading']}>Greenfund.ai</div>
                        <div className={classes['content-body']}>An AI-powered financing platform designed to source capital for clean energy and AI-related projects — accelerating development with smarter, faster funding solutions.</div>
                    </div>

                </div>
                <div className={classes['clean-energy-marketplace-container']}>
                    <div className={classes['logo-conatiner']}>
                        <div className={classes['logo-frame']}>
                            <div className={classes['logo-inside-frame']}>
                                <GreenfundAi />
                            </div>
                        </div>
                    </div>
                    <div className={classes['content-container']}>
                        <div className={classes['content-heading']}>Clean Energy Marketplace</div>
                        <div className={classes['content-body']}>A blockchain and AI-driven marketplace for buying and selling clean energy assets. It streamlines transactions, ensures transparency, and supports projects with access to low-cost capital.</div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default AiUseCases